

































import Vue from "vue";
import { onMounted, computed } from "@vue/composition-api";
import { getMipConcentUrl } from "@/common/api/integrations.api";
import { common_state } from "./data/common.state";
export default Vue.extend({
  setup(_, { emit }) {
    const isActivated = computed(() => common_state.state.isMipActivated);
    onMounted(() => {
      emit("enableNext", isActivated.value);
    });

    const giveConsent = async () => {
      const res = await getMipConcentUrl();
      if (res.success) {
        window.open(res.value, "_self");
      }
    };
    return { giveConsent };
  },
});
